document.addEventListener("DOMContentLoaded", function () {
  const defaultText = "Add to Cart";

  function sanitizeBundleAddToCart() {
    const bundleBtnText = document.querySelector('.cxBundleBtn .upsell-add-cart-btn-text');
    if (!bundleBtnText) return;

    const currentText = bundleBtnText.textContent.trim();

    console.log("📦 Bundle Button Text:", currentText);

    if (currentText.includes("Save - $0.00")) {
      bundleBtnText.textContent = defaultText;
      console.log("🧼 Removed 'Save - $0.00' from bundle button");
    }
  }

  // Initial check
  sanitizeBundleAddToCart();

  // Retry a few times (in case MaxBundle injects later)
  let retries = 0;
  const interval = setInterval(() => {
    sanitizeBundleAddToCart();
    retries++;
    if (retries > 20) clearInterval(interval);
  }, 300);

  // Observe container for live swaps
  const container = document.querySelector('.product-form__buttons');
  if (container) {
    const observer = new MutationObserver(() => {
      sanitizeBundleAddToCart();
    });
    observer.observe(container, { childList: true, subtree: true });
  }
});